import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { find, isEmpty, sortBy } from "lodash";

import RequestFilter from "../components/requests/RequestFilter";
import RequestTable from "../components/requests/RequestTable";
import { Button, FontIcon } from "react-md";


import { getPage, updateRequestResource } from "../actions/resourceActions";
import { getRequest, setFilter } from "../actions/requestActions";
import { getUser } from "../actions/userActions";
import {createUrlForNewRequestToField} from "../Atollon/Request_PreselectFieldsInRequest";
import {TouchPageHeader} from "../AtollonTheme/ReactElements";

const Page = ({ history, page, requests, filter }) => {
  if (!page) return <div />;
  return (
    <div className="flex-col">
        <TouchPageHeader
            title={`Vítejte na stránce${page
            ? ` ${page.name ? page.name : page.identifier}`
            : ""}`}
            buttons={(
                <Button
                    raised
                    className="btn btn-primary touchButton-1"
                    label="Nový požadavek"
                    onClick={() => history.push( createUrlForNewRequestToField( "/request-new", page.identifier ))}
                >
                    <FontIcon className="color-white">album</FontIcon>
                </Button>
            )}
        />
      <RequestFilter
        title={''}
        pageRequests
        identifier={page.identifier}
        {...{ history, filter }}
      />
      <RequestTable
        pageRequests
        identifier={page.identifier}
        {...{ history, filter, requests }}
      />
    </div>
  );
};

export default compose(
  connect(
    ({ resource: { page }, request: { requests, filter } }) => ({
      page,
      requests,
      filter
    }),
    {
      getPage,
      getRequest,
      setFilter,
      getUser,
      updateRequestResource
    }
  ),
  lifecycle({
    async componentWillMount() {
      const {
        getPage,
        match,
        getRequest,
        setFilter,
        getUser,
        updateRequestResource
      } = this.props;

      const organizationIdentifier = match.params.id;

      setFilter(
        false,
        false,
        false,
        false,
        false,
        false,
        "",
        10,
        "CREATED",
        "ANY"
      );
      const pageOk = await getPage(organizationIdentifier);
      getRequest({
        includeCount: true,
        limit: 10,
        side: null,
        recipient: organizationIdentifier,
        sender: organizationIdentifier
      });

      const user = await getUser();

      let addOrganizationToMyDashboard = async () =>
      {
          console.log('addOrganizationToMyDashboard',{ 'user.relatedResources': sortBy( user.relatedResources, ['identifier']), organizationIdentifier });

          if (
              pageOk &&
              user &&
              !find(
                  user.relatedResources,
                  item =>
                      item.identifier === organizationIdentifier && item.role === "PROVIDER"
              )
          )
          {
              const provider = {identifier: organizationIdentifier, role: "PROVIDER"};

              console.log('addOrganizationToMyDashboard', {provider});
              if (
                  await updateRequestResource({
                  ...user,
                  relatedResources: !isEmpty(user.relatedResources)
                      ? [...user.relatedResources, provider]
                      : [provider]
              }))
              {
                  getUser();
              }
          }
      };
      addOrganizationToMyDashboard();
    }
  })
)(Page);



// WEBPACK FOOTER //
// ./src/pages/Page.js